
export const checkForInitials = ({signers, type, rootDocData, requiredOpenFor, contractData, signDetails, signerFields }) => {
    const isSellerInitialsPresent = contractData?.sellerFields?.default?.initialsPresent || contractData?.sellerFields?.initialsPresent;
    const isBuyerInitialsPresent = contractData?.buyerFields?.default?.initialsPresent || contractData?.buyerFields?.initialsPresent;

    if (!isSellerInitialsPresent && !isBuyerInitialsPresent) {
        return "";
    }

    const sellersFieldsInTheForm = document.querySelectorAll(`[data-initial-box="SELLERS"]`);
    const buyersFieldInTheForm = document.querySelectorAll(`[data-initial-box="BUYERS"]`);

    if (sellersFieldsInTheForm?.length === 0 && buyersFieldInTheForm?.length === 0) {
        return "";
    }

    if (type === "Sellers") {
        sellersFieldsInTheForm?.forEach(container => {
            container.innerHTML = "";
        });
    } else if (type === "Buyers") {
        buyersFieldInTheForm?.forEach(container => {
            container.innerHTML = "";
        });
    }


    // let signerFields = {};
    // if (type === "Sellers") {
    //     signerFields = signDetails || contractData?.sellerFields || {};
    // } else if (type === "Buyers") {
    //     signerFields = signDetails || contractData?.buyerFields || {};
    // }

    let initialsHtml = "";

    signers.forEach((element) => {
        if (element?.isCorp) {
            element?.signers?.forEach((signer) => {
                const signerId = `${requiredOpenFor}_${signer?.personId}_key_${element?.key}${signerFields?.labelType ? `_${signerFields?.labelType}` : ""}`;
                initialsHtml += `
                    <span class="grow-with-input" title="${signer?.fullName || "Initial"}">
                        <input type="text" class="grow initialInputBox" name="${signerId}" data-${type.toLowerCase()}-initial-box size="2" maxLength="2" />
                    </span>
                `;
            });
        } else {
            const uuidKey = element?.key || element?.personId;
            const personId = element?.personId || element?._id || requiredOpenFor;
            const signerId = `${requiredOpenFor}_${personId}_key_${uuidKey}${signerFields?.labelType ? `_${signerFields?.labelType}` : ""}`;
            initialsHtml += `
                <span class="grow-with-input" title="${element?.fullName || "Initial"}">
                    <input type="text" class="grow initialInputBox" name="${signerId}" data-${type.toLowerCase()}-initial-box size="2" maxLength="2" />
                </span>
            `;
        }
    });

    // Append the initials HTML only to the relevant DOM field
    if (type === "Sellers" && sellersFieldsInTheForm?.length > 0) {
        sellersFieldsInTheForm?.forEach((field) => {
            field.innerHTML += initialsHtml;
        });
    } else if (type === "Buyers" && buyersFieldInTheForm?.length > 0) {
        buyersFieldInTheForm?.forEach((field) => {
            field.innerHTML += initialsHtml;
        });
    }
};

/*

DYNAMIC_CLIENT_REVERSE / DYNAMIC_CLIENT / SELLERS / BUYERS

<span data-initial-box="SELLERS">
    // WRAP THE INITIAL FIELD OF THE CONTRACT WITH THIS SPAN
</span>

*/